import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Container,
    Embed,
    Header,
    Label,
    Modal,
    Segment
} from 'semantic-ui-react';
import { useAuth } from '../providers';

const Onboarding = () => {
    const [luaDebugOpen, setLuaDebugOpen] = useState(false);
    const { user } = useAuth();

    return (
        <Segment className='lobby' inverted>
            <Container text className='description'>
                <Header inverted>Welcome {user['display']}!</Header>
                <Header inverted as='h3'>
                    Quick Setup
                </Header>
                <p>
                    Installation of the mod is really straight forward, and is less time consuming than it seems. However, it is important to follow all of the steps below to ensure it works as expected.
                </p>
                <p>
                    <ol>
                        <li>Subscribe to the mod in the Steam Workshop by clicking <a href='https://steamcommunity.com/sharedfiles/filedetails/?id=2493976911'>this link</a>.</li>
                        <li>Configure Isaac to allow networking by enabling lua debug mode:
                            <Modal
                                basic
                                onClose={() => setLuaDebugOpen(false)}
                                onOpen={() => setLuaDebugOpen(true)}
                                open={luaDebugOpen}
                                size='small'
                                trigger={<Link>View Video (15 seconds)</Link>}
                            >
                                <Modal.Content>
                                    <Embed id='NhfpNrvsTUQ' source='youtube' autoplay={true} />
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button basic color='green' inverted onClick={() => setLuaDebugOpen(false)}>Close</Button>
                                </Modal.Actions>
                            </Modal>
                        </li>
                        <ol type='a'>
                            <li>In your Steam Library, right click on Isaac, and select properties.</li>
                            <li>On the properties screen, enter <code>--luadebug</code> in the Launch Options input. Make sure you include two dashes!</li>
                            <li>Close the properties window.</li>
                        </ol>
                        <li>Start up Isaac, and the mod will be automatically downloaded from the Steam Workshop.</li>
                        <li>Start a new run of Isaac. On your first run with the mod, the Twitching of Isaac menu should automatically open -- if it does not, you can access it via the <code>F8</code> key (and can use the <code>F8</code> key in the future to open or close the menu).</li>
                        <li>Press <code>Enter</code> on the keyboard, or use your controller or mouse to access the registration screen, and enter your unique registration token: <Label>{user['token']}</Label>.</li>
                        <li>Press <code>Enter</code> on the keyboard, or use your controller or mouse to save and connect to the mod server. If the main screen now says you are connected, everything has worked as expected! The bot will auto-join your channel whenever you start the game with the mod enabled.</li>
                        <li>Give your chat the following help link, that will be customized based on how you configure commands: <a href={`/help/${user['username']}`}>https://{window.location.hostname}/help/{user['username']}</a>. This link is available to your chat via the <code>!help</code> command in chat, however if you have follower only chat, or block links from being posted, then the bot may struggle to share this page with your community.</li>
                    </ol>
                </p>
                <Header inverted as='h3'>
                    Useful Hints
                </Header>
                <p>
                    <ul>
                        <li>
                            The Twitching of Isaac has a lot of configuration options. While you can do basic command management from within the mod, such as enable/disable a command, or mark it Subscriber only, you can perform advanced command management here on the website. Visit <a href="/dashboard/commands">the Commands page</a> to set rate limits, ban items, or other advanced configuration options on a command level. You can even rename commands to suit your needs, or translate them in to a different language!
                        </li>
                        <li>
                            There's so many other things you can do with the mod, including <a href="/dashboard/tips">Donation based incentives</a>, and creating <a href="/dashboard/custom">Custom Commands</a>. Please check out the <a href="/dashboard">Dashboard</a> (which will be your default login page in the future) to see everything you can do.
                        </li>
                        <li>
                            If you need any help, have ideas, or just want to join the community, please join us in the <a href="https://discord.gg/FtJyJNcz2k">Twitching of Isaac Discord</a>!
                        </li>
                    </ul>
                </p>
            </Container>
        </Segment>
    )
};

export default Onboarding;
